import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

function Field({ label, children }) {
  return (
    <div>
      <Label className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 mb-1 block">{label}</Label>
      {children}
    </div>
  );
}

/**
 * PurchaseHeaderFields — extracted from PurchaseUploadSheet.jsx (iter49 refactor).
 * 6-field grid: Vendor · GSTIN · Invoice # · Date · Project link · Tax type.
 *
 * Props
 *   • form / setForm      — form-state hook
 *   • projectId / setProjectId — project link
 *   • interstate / setInterstate — CGST-SGST vs IGST toggle
 *   • projects[]          — dropdown options
 */
export default function PurchaseHeaderFields({ form, setForm, projectId, setProjectId, interstate, setInterstate, projects }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <Field label="Vendor Name">
        <Input value={form.vendor} onChange={(e) => setForm({ ...form, vendor: e.target.value })} data-testid="upload-purchase-vendor" />
      </Field>
      <Field label="Vendor GSTIN">
        <Input value={form.vendor_gstin} onChange={(e) => setForm({ ...form, vendor_gstin: e.target.value })} className="font-mono uppercase" />
      </Field>
      <Field label="Invoice / Bill Number">
        <Input value={form.invoice_number} onChange={(e) => setForm({ ...form, invoice_number: e.target.value })} placeholder="INV-2026-001" />
      </Field>
      <Field label="Bill Date">
        <Input type="date" data-testid="upload-purchase-date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
      </Field>
      <Field label="Link Project (optional)">
        <Select value={projectId || "__none__"} onValueChange={(v) => setProjectId(v === "__none__" ? "" : v)}>
          <SelectTrigger data-testid="upload-purchase-project"><SelectValue placeholder="None" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="__none__">None</SelectItem>
            {(projects || []).map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </Field>
      <Field label="Tax Type">
        <Select value={interstate ? "igst" : "cgst"} onValueChange={(v) => setInterstate(v === "igst")}>
          <SelectTrigger data-testid="upload-purchase-interstate"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="cgst">Intra-state (CGST + SGST)</SelectItem>
            <SelectItem value="igst">Inter-state (IGST)</SelectItem>
          </SelectContent>
        </Select>
      </Field>
    </div>
  );
}
